module.exports = __webpack_public_path__ + "img/globe.c51134e5.jpeg";